import { render, staticRenderFns } from "./EventListItem.vue?vue&type=template&id=46634836"
import script from "./EventListItem.ts?vue&type=script&lang=ts&external"
export * from "./EventListItem.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports